import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getRequestedPacksAction } from "../../Redux/Action/PackAction";
import { useDispatch, useSelector } from "react-redux";
import { truncateTextbrowse } from "../../Util/HelperFunction";
import LoaderComponent from "../../Components/common/LoaderComponent";
import SearchBar from "../../Components/common/SearchBar";

const RequestedPacks = ({ searchValue }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const requestedPacksData = useSelector((state) => state?.PackSlice?.requests);
  const { isLoading } = useSelector((state) => state?.PackSlice);

  useEffect(() => {
    dispatch(getRequestedPacksAction({ searchValue }));
  }, [searchValue, dispatch]);

  return (
    <>
      {isLoading ? (
        <LoaderComponent />
      ) : (
        <Container fluid className="packs-container">
          {requestedPacksData?.videoPacks?.length > 0 ? (
            <Row className="me-5">
              {requestedPacksData?.videoPacks?.map((request) => {
                const pack = request;
                return (
                  <Col
                    key={request?._id}
                    xl={3}
                    lg={6}
                    md={6}
                    className="mb-4 w-25 cursor-pointer"
                    style={{ overflow: 'visible' }}
                  >
                    <div className="pack-card">
                      <span className="notification-dot"></span>
                      <img
                        src={request?.videoPackId?.image}
                        alt="Pack Image"
                        className="pack-image"
                      />
                      <div className="pack-content">
                        <div className="d-flex justify-content-between align-items-center">
                          <h5>{request?.videoPackId?.title}</h5>
                          <span className="badge text-white bg-primary ">
                            {request?.status?.charAt(0).toUpperCase() +
                              request?.status?.slice(1)}
                          </span>
                        </div>
                        <p>
                          {request?.description
                            ? truncateTextbrowse(request?.description, 4)
                            : null}
                        </p>
                        <span className="video-count">
                          {request?.videoPackId?.videosCount} Videos
                        </span>
                        <div className="request-info mt-2">
                          <small className="text-muted">
                            Requested by: {request?.requestedBy?.schoolName}
                          </small>
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div className="text-center mt-5 py-5">
              <p>No Requested Packs Found</p>
            </div>
          )}
        </Container>
      )}
    </>
  );
};

export default RequestedPacks;
